import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS, LANGUAGE_LABELS, type SupportedLang } from "@/i18n";
import { cn } from "@/lib/cn";

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage as SupportedLang;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          className={cn(
            "inline-flex min-h-[36px] items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium",
            "text-ink-muted hover:text-ink hover:bg-surface",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber",
          )}
          aria-label="Přepnout jazyk"
        >
          <Languages size={16} />
          <span className="uppercase tracking-[0.08em]">{current}</span>
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={8}
          className={cn(
            "z-50 min-w-[140px] rounded-xl border border-stroke-strong bg-surface",
            "p-1 shadow-xl",
          )}
        >
          {SUPPORTED_LANGS.map((lng) => (
            <DropdownMenu.Item
              key={lng}
              onSelect={() => {
                void i18n.changeLanguage(lng);
              }}
              className={cn(
                "cursor-pointer rounded-lg px-2.5 py-1.5 text-sm",
                "text-ink-muted hover:bg-surface-raised hover:text-ink",
                "focus:bg-surface-raised focus:outline-none",
                lng === current && "text-amber-bright bg-amber-dim",
              )}
            >
              {LANGUAGE_LABELS[lng]}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
